import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { gsap } from 'gsap'
import { theme } from '../../theme/theme'
import { BrowserView } from 'react-device-detect'

const CursorFollower = styled.div`
    width: 50px;
    height: 50px;
    transform: translateY(-50%) translateX(-50%);
    position: fixed;
    top: 0;
    left: 0;
    border: 3px solid ${theme.yellow};
    border-radius: 50%;
    pointer-events: none;
    z-index: 999;

    &.active {
        width: 100px;
        height: 100px;
        background: ${theme.yellowTrans};
        border: none;
    }

    &.menu-active {
        opacity: 1;
        transform: scale(2);
    }

    &.hovered {
        opacity: 1;
    }
`

const Cursor = () => {
    const cursorRef = useRef()

    useEffect(() => {
        gsap.to(cursorRef.current, {
            x: '-100%',
            y: '-100%',
        })

        let xTo = gsap.quickTo(cursorRef.current, 'x', {
                duration: 0.45,
                ease: 'power3',
            }),
            yTo = gsap.quickTo(cursorRef.current, 'y', {
                duration: 0.45,
                ease: 'power3',
            })

        window.addEventListener('mousemove', (e) => {
            xTo(e.clientX)
            yTo(e.clientY)
        })
    })

    return (
        <BrowserView>
            <CursorFollower id="cursor_follower" ref={cursorRef} />
        </BrowserView>
    )
}

export default Cursor
